import { render } from "./primary-button.vue?vue&type=template&id=fa1dbc0e"
import script from "./primary-button.vue?vue&type=script&lang=js"
export * from "./primary-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__